import * as XLSX from 'xlsx';

import { LinhaDaEquipe, rotuloDoStatus } from './minha-equipe-calculos';

/** Planilha da equipe inteira da visão atual (EQP-50). Métrica indisponível sai como "—". */

const INDISPONIVEL = '—';
const valor = (numero: number | null) => (numero === null ? INDISPONIVEL : numero);

export function linhasDaPlanilha(linhas: LinhaDaEquipe[], cicloSelos: string | null) {
  const colunaDeSelos = cicloSelos ? `Selos (${cicloSelos})` : 'Selos';

  return linhas.map(linha => ({
    Nome: linha.nome,
    Chave: linha.chave,
    Unidade: linha.diretoria,
    Cargo: linha.funcao,
    'Pontos do ciclo': valor(linha.pontos),
    [colunaDeSelos]: valor(linha.selos),
    'Reconhecimentos recebidos': valor(linha.reconhecimentos),
    'Status na fase': linha.status ? rotuloDoStatus(linha.status).rotulo : INDISPONIVEL,
  }));
}

export function nomeDoArquivo(ciclo: string): string {
  return `minha-equipe-${ciclo}.xlsx`;
}

/** Gera e baixa o arquivo; erro de escrita propaga para a tela mostrar a falha (EQP-52). */
export function exportarEquipe(linhas: LinhaDaEquipe[], ciclo: string, cicloSelos: string | null): void {
  const planilha = XLSX.utils.json_to_sheet(linhasDaPlanilha(linhas, cicloSelos));
  const arquivo = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(arquivo, planilha, 'Minha Equipe');
  XLSX.writeFile(arquivo, nomeDoArquivo(ciclo));
}
